import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";
import { TrendingUp, TrendingDown } from "lucide-react";

export default function AssetPriceCard({ asset }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.1 }}
    >
      <Card className="glass-effect mb-8">
        <CardContent className="p-8">
          <div className="flex items-end gap-4 mb-4">
            <div className="text-6xl font-bold text-white mono" data-testid="asset-price">
              ${asset.price.toLocaleString()}
            </div>
            <div className="flex items-center gap-2 pb-2">
              {asset.change_24h >= 0
                ? <TrendingUp className="w-6 h-6 text-[#00FFA3]" />
                : <TrendingDown className="w-6 h-6 text-[#FF3B30]" />}
              <span className={`text-2xl font-bold ${asset.change_24h >= 0 ? 'text-[#00FFA3]' : 'text-[#FF3B30]'}`}>
                {asset.change_24h >= 0 ? '+' : ''}{asset.change_24h.toFixed(2)}%
              </span>
            </div>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 pt-6 border-t border-white/5">
            <div>
              <div className="text-sm text-gray-500 mb-1">24h Volume</div>
              <div className="text-lg font-semibold text-white mono">
                ${(asset.volume / 1000000).toFixed(2)}M
              </div>
            </div>
            {asset.market_cap && (
              <div>
                <div className="text-sm text-gray-500 mb-1">Market Cap</div>
                <div className="text-lg font-semibold text-white mono">
                  ${(asset.market_cap / 1000000000).toFixed(2)}B
                </div>
              </div>
            )}
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
}
